<template>
  <div class="text-[18px] text-black mb-[6px] mt-[40px] font-semibold">{{ $t('space.have_problem') }}</div>
  <NuxtLink :to="getLineUrl"
            target="_blank"
            class="flex items-center text-[16px]">
    <svg-icon
        class="mr-2 cursor-pointer"
        name="line"
        size="38"
    />

    <div class="mr-4">
      <p>官方Line</p>
      <p>@768cpmhz</p>
    </div>
    <div class=""><p>聯絡電話</p> <p>02-66236940</p></div>
  </NuxtLink>

</template>

<script setup
        lang="ts">
import {adminCustomerLineUrl} from "~/config/common.js";

const props = defineProps({
  adminId: {
    type: Number,
    default: 0
  },
})

const clientLineUrl = ref(import.meta.env.VITE_APP_BASE_CLIENT_LINE_URL)
const lineUrl = import.meta.env.VITE_APP_BASE_LINE_URL

const getLineUrl = computed(() => {
  // return adminCustomerLineUrl[props.adminId] ? adminCustomerLineUrl[props.adminId] : lineUrl.value
  return lineUrl
})
</script>

<style scoped
       lang="scss">

</style>
